export default "__VITE_ASSET__9c1b5084__"